import type { Role } from '@cockpit/shared';

export interface TabDef {
  /** Nom de la route (et identifiant de l'onglet dans la maquette). */
  name: string;
  path: string;
  label: string;
  adminOnly?: boolean;
}

/** Onglets dans l'ordre de la maquette ; Réglages est réservé à l'administrateur. */
export const TABS: readonly TabDef[] = [
  { name: 'afaire', path: '/a-faire', label: 'À faire' },
  // Lot BB : conversations Crisp et mails des clients, fournisseurs, mémoire.
  { name: 'support', path: '/support', label: 'Support' },
  { name: 'projets', path: '/projets', label: 'Projets' },
  { name: 'conseiller', path: '/conseiller', label: 'Conseiller' },
  { name: 'chiffres', path: '/chiffres', label: 'Chiffres' },
  { name: 'tresorerie', path: '/tresorerie', label: 'Trésorerie' },
  { name: 'depenses', path: '/depenses', label: 'Dépenses' },
  { name: 'carte', path: '/carte', label: 'Carte' },
  { name: 'agenda', path: '/agenda', label: 'Agenda' },
  { name: 'apporteurs', path: '/apporteurs', label: 'Apporteurs' },
  { name: 'retours', path: '/retours', label: 'Retours' },
  { name: 'reglages', path: '/reglages', label: 'Réglages', adminOnly: true },
];

export const HOME_PATH = '/a-faire';
export const LOGIN_PATH = '/login';

export function visibleTabs(role: Role | null | undefined): TabDef[] {
  return TABS.filter((tab) => !tab.adminOnly || role === 'ADMIN');
}

export const ROLE_LABELS: Record<Role, string> = { ADMIN: 'Administrateur', MEMBER: 'Membre' };

export interface GuardTarget {
  path: string;
  fullPath: string;
  meta: { public?: boolean; adminOnly?: boolean };
}

/**
 * Décision de navigation (logique pure, testée) : `true` pour laisser passer,
 * sinon le chemin vers lequel rediriger.
 */
export function guardDecision(to: GuardTarget, user: { role: Role } | null): true | string {
  if (to.meta.public) {
    return to.path === LOGIN_PATH && user ? HOME_PATH : true;
  }
  if (!user) {
    return to.fullPath && to.fullPath !== '/' && to.fullPath !== HOME_PATH
      ? `${LOGIN_PATH}?redirect=${encodeURIComponent(to.fullPath)}`
      : LOGIN_PATH;
  }
  if (to.meta.adminOnly && user.role !== 'ADMIN') return HOME_PATH;
  return true;
}

/** N'accepte qu'un chemin interne comme cible de retour après connexion. */
export function safeRedirect(value: unknown): string {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') ? value : HOME_PATH;
}
